import './Summary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { defaultTimelineFilterParams } from './TimelineView';
import { getTimelineSummarySelector } from './@arch/selectors';
import { SonarAlert } from '@ui/SonarAlert';
import { SonarCard } from '@ui/general/SonarCard';
import { TimelineDatePicker } from './TimelineDatePicker';
import { TimelineSynopsis } from './TimelineSynopsis';
import { UserChangesChart } from './UserChangesChart';
import { GroupedChangesChart } from './GroupedChangesChart';
import React, { useCallback, useMemo, useState } from 'react';
import { TimelineFilters } from './filters/TimelineFilters';
import { useSonarSelector } from '@hooks';
export const TimelineSummary = ({ onChange, params }) => {
    const data = useSonarSelector(getTimelineSummarySelector.data);
    const [highlightedChangeType, setHighlightedChangeType] = useState();
    const [selectedChangeType, setSelectedChangeType] = useState();
    const clearSelectedChangeType = useCallback(() => {
        setSelectedChangeType(undefined);
    }, []);
    const clearFilters = useCallback(() => {
        onChange(Object.assign(Object.assign({}, params), defaultTimelineFilterParams));
    }, [onChange, params]);
    const hasFiltersApplied = useMemo(() => {
        const { applicationIds, tagIds, objectFilter, modifiedByUsernames, system, objectNameFilter, isFollowing } = params;
        return Boolean(objectNameFilter ||
            !system ||
            (modifiedByUsernames === null || modifiedByUsernames === void 0 ? void 0 : modifiedByUsernames.length) ||
            Object.keys(objectFilter !== null && objectFilter !== void 0 ? objectFilter : {}).length ||
            isFollowing !== undefined ||
            (applicationIds === null || applicationIds === void 0 ? void 0 : applicationIds.length) ||
            (tagIds === null || tagIds === void 0 ? void 0 : tagIds.length));
    }, [params]);
    const extra = React.createElement(TimelineDatePicker, { endDate: params.end, onChange: onChange, startDate: params.start });
    return (React.createElement(SonarCard, { bordered: false, extra: data ? extra : null, id: 'timeline-summary', loading: !data, title: COPY_SPECIFIC.TIMELINE_SUMMARY },
        React.createElement(SonarAlert, { active: hasFiltersApplied, afterClose: clearFilters, closable: true, closeText: COPY_SPECIFIC.CLEAR_FILTERS, message: COPY_SPECIFIC.FILTERS_APPLIED, showIcon: true, type: 'info' }),
        React.createElement("div", { className: 'summary-sections' },
            React.createElement(TimelineFilters, { clearSelectedChangeType: clearSelectedChangeType, highlightedChangeType: highlightedChangeType, onChange: onChange, params: params, selectedChangeType: selectedChangeType }),
            React.createElement("div", { className: 'charts-and-stats' },
                React.createElement("div", { className: 'top-section' },
                    React.createElement(TimelineSynopsis, { hideSystem: !(params === null || params === void 0 ? void 0 : params.system), onChange: onChange, onChangeTypeClicked: setSelectedChangeType, onChangeTypeHovered: setHighlightedChangeType }),
                    React.createElement(UserChangesChart, { modifiedBy: params === null || params === void 0 ? void 0 : params.modifiedByUsernames, onChange: onChange })),
                React.createElement(GroupedChangesChart, { grouping: params.timelineGroupingType, onChange: onChange })))));
};
